import { ReactNode } from "react";

import styles from "../cart.module.css";

type FooterItemProps = {
  left: ReactNode;
  right: ReactNode;
  size: "s" | "m";
};

export const FooterItem = ({ left, right, size }: FooterItemProps) => (
  <div className={`${styles.footerItem} ${styles[size]}`}>
    <div>{left}</div>
    <div>{right}</div>
  </div>
);
